import React from 'react';
import { X, Sparkles } from 'lucide-react';

export default function VideoModal({ introVideo, personaInfo, presentationStarted, onDismiss }) {
    if (!introVideo) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
            <div className="relative max-w-3xl w-full mx-4">
                <div className="bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
                    <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#5764F4] to-purple-500 flex items-center justify-center overflow-hidden">
                                {personaInfo?.avatar ? (
                                    <img src={personaInfo.avatar} alt="" className="w-full h-full object-cover" />
                                ) : (
                                    <Sparkles className="w-4 h-4 text-white" />
                                )}
                            </div>
                            <div>
                                <p className="text-white text-sm font-semibold">Message d'introduction</p>
                                <p className="text-gray-400 text-xs">De la part d'Abdoulaye Diallo</p>
                            </div>
                        </div>
                        <button onClick={onDismiss}
                            className="text-gray-400 hover:text-white transition-colors">
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                    <div className="aspect-video bg-black">
                        <video
                            src={introVideo}
                            controls
                            autoPlay
                            className="w-full h-full object-contain"
                        />
                    </div>
                    <div className="p-4 flex justify-end">
                        <button onClick={onDismiss}
                            className="bg-[#5764F4] hover:bg-[#4654E3] text-white px-6 py-2 rounded-lg font-medium transition-colors text-sm">
                            {presentationStarted ? 'Fermer' : 'Passer à la présentation →'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
